import styled from "styled-components"

export const Label = styled.div``

export const StyledButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const StyledVariant = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
